import z from 'zod';
import { Grade, GRADE_LABELS, Subject, SUBJECT_LABELS, UserGroup, XeroDepartment } from './enums';
import { CountrySchema, ProfileIconSchema } from './schemas';

export const StaffUserGroups = [
  UserGroup.Teachers,
  UserGroup.Admins,
  UserGroup.Managers,
  UserGroup.Owners,
  UserGroup.BillingOfficers,
  UserGroup.PayrollOfficers,
  UserGroup.ShiftManagers,
  UserGroup.CourseManagers,
  UserGroup.CourseDevelopers,
];

export const DEFAULT_PROFILE_ICON: z.infer<typeof ProfileIconSchema> = {
  color: '#0c374d',
};

export const DEFAULT_COUNTRY: z.infer<typeof CountrySchema> = 'Australia';

/** The question bank's subject vocabulary code for each subject a lesson is taught in. */
export const QUESTION_BANK_SUBJECT_CODES: Readonly<Record<Subject, string>> = {
  [Subject.Chemistry]: 'chemistry',
  [Subject.Physics]: 'physics',
  [Subject.MathsExt1]: 'maths',
  [Subject.MathsExt2]: 'maths',
};

export const SUBJECTS = [
  {
    key: Subject.Chemistry,
    value: Subject.Chemistry,
    label: SUBJECT_LABELS[Subject.Chemistry],
    xeroDepartment: {
      name: 'Department',
      option: XeroDepartment.Chemistry,
    },
  },
  {
    key: Subject.Physics,
    value: Subject.Physics,
    label: SUBJECT_LABELS[Subject.Physics],
    xeroDepartment: {
      name: 'Department',
      option: XeroDepartment.Physics,
    },
  },
  {
    key: Subject.MathsExt1,
    value: Subject.MathsExt1,
    label: SUBJECT_LABELS[Subject.MathsExt1],
    xeroDepartment: {
      name: 'Department',
      option: XeroDepartment.Mathematics,
    },
  },
  {
    key: Subject.MathsExt2,
    value: Subject.MathsExt2,
    label: SUBJECT_LABELS[Subject.MathsExt2],
    xeroDepartment: {
      name: 'Department',
      option: XeroDepartment.Mathematics,
    },
  },
];

export const GRADES = [
  {
    key: Grade.HSC,
    value: Grade.HSC,
    label: GRADE_LABELS[Grade.HSC],
  },
  {
    key: Grade.Prelim,
    value: Grade.Prelim,
    label: GRADE_LABELS[Grade.Prelim],
  },
];
